/* src/app/components/shared/shopping-widgets/shopping-widgets.component.scss */
.h-32 {
  height: 32px;
}
/*# sourceMappingURL=shopping-widgets.component.css.map */
